import React from 'react';
import {
  Box,
  Typography,
  Chip,
  Button,
  Divider,
} from '@mui/material';
import {
  YouTube as TwitchIcon,
  CalendarToday as CalendarIcon,
  FavoriteBorder as HeartIcon,
} from '@mui/icons-material';

const TouchePasAMonMateProject: React.FC = () => {
  return (
    <Box>
      {/* Header avec titre et image */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <img
          src="/Twitch/TouchePasAMonMate.png"
          alt="Logo Touche pas à mon mate"
          style={{
            width: '64px',
            height: '64px',
            objectFit: 'contain',
            filter: 'drop-shadow(2px 2px 4px rgba(167, 139, 250, 0.3))',
          }}
        />
        <Typography
          variant="h4"
          component="h2"
          sx={{ 
            background: 'linear-gradient(135deg, #a78bfa 0%, #14b8a6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontWeight: 'bold' 
          }}
        >
          Touche pas à mon mate
        </Typography>
      </Box>

      {/* Statut et date */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CalendarIcon sx={{ fontSize: '1rem', color: 'text.secondary' }} />
          <Typography variant="body2" color="text.secondary">
            2022
          </Typography>
        </Box>
      </Box>

      {/* Description */}
      <Typography
        variant="body1"
        sx={{ mb: 3, lineHeight: 1.6 }}
      >
        Mod Unity développé pour l'émission "Touche pas à mon mate" basée sur Among Us. 
        Les streamers se retrouvent sur le même plateau pour jouer ensemble, et le mod 
        affiche en temps réel les battements de cœur de chaque participant directement 
        dans le jeu et sur le stream.
      </Typography>

      <Divider sx={{ my: 3 }} />

      {/* Fonctionnalités principales */}
      <Box sx={{ mb: 3 }}>
        <Typography 
          variant="h6" 
          gutterBottom 
          sx={{ 
            background: 'linear-gradient(135deg, #a78bfa 0%, #14b8a6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontWeight: 'bold' 
          }}
        >
          Fonctionnalités principales
        </Typography>
        <Box sx={{ 
          display: 'grid', 
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, 
          gap: 2 
        }}>
          <Box>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Capteurs cardiaques en temps réel
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Affichage in-game des battements
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Overlay stream personnalisé
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Synchronisation multi-joueurs
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Alertes de stress détectées
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Données en temps réel
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Intégration Among Us
            </Typography>
          </Box>
        </Box>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Technologies */}
      <Box sx={{ mb: 3 }}>
        <Typography 
          variant="h6" 
          gutterBottom 
          sx={{ 
            background: 'linear-gradient(135deg, #a78bfa 0%, #14b8a6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontWeight: 'bold' 
          }}
        >
          Technologies utilisées
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {['Unity', 'C#', 'API Capteurs cardiaques', 'Among Us Modding', 'WebSocket', 'OBS Integration'].map((tech) => (
            <Chip
              key={tech}
              label={tech}
              variant="filled"
              size="small"
              sx={{
                background: 'linear-gradient(135deg, rgba(167, 139, 250, 0.1) 0%, rgba(20, 184, 166, 0.1) 100%)',
                color: '#a78bfa',
                border: '1px solid rgba(167, 139, 250, 0.3)',
                '&:hover': {
                  background: 'linear-gradient(135deg, rgba(167, 139, 250, 0.2) 0%, rgba(20, 184, 166, 0.2) 100%)',
                },
              }}
            />
          ))}
        </Box>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Liens actions */}
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        <Button
          variant="contained"
          startIcon={<TwitchIcon />}
          href="https://www.youtube.com/watch?v=hQK594gvo8k"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            background: 'linear-gradient(135deg, #a78bfa 0%, #14b8a6 100%)',
            '&:hover': {
              background: 'linear-gradient(135deg, #8b5cf6 0%, #0f766e 100%)',
            },
          }}
        >
          Voir l'émission
        </Button>
      </Box>
    </Box>
  );
};

export default TouchePasAMonMateProject;

